angular.module('elogbooksFilters').filter('indent', function() {
    return function(count) {
        return new Array(count + 1).join('\u00a0\u00a0');
    };
});
